{
    "UserTour_Next": "Seguinte",
    "UserTour_Cancel": "Mostrar-me mais tarde",
    "UserTour_Exit": "Desativar visita guiada",
    "NAME": "UserTour"
}